import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, EffectNotification, ofType, OnRunEffects } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { exhaustMap, takeUntil, catchError, map, switchMap } from 'rxjs/operators';
import * as authActions from '../actions/auth.actions';
import * as startupActions from '../actions/startup.actions';
import * as errorActions from '../actions/error.actions';
import { AuthService } from '@app-root-services';
import { IAuthResponse, IError } from '@app-root-interfaces';

@Injectable()
export class StartupEffects implements OnRunEffects {
    private actions$ = inject(Actions);
    private authService = inject(AuthService);

    getTokenUserData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(startupActions.getTokenUserData),
            switchMap(() =>
                this.authService.getLoginData().pipe(
                    map((authResponse: IAuthResponse) => authActions.checkToken({ authResponse })),
                    catchError((err) => {
                        const error: IError = {
                            obj: err,
                            isCritical: false,
                            text: 'startup-error-get-token'
                        };
                        return of(errorActions.addError({ error }));
                    })
                )
            )
        )
    );

    ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>): Observable<EffectNotification> {
        return this.actions$.pipe(
            ofType(startupActions.startAppInitializer),
            exhaustMap(() =>
                resolvedEffects$.pipe(takeUntil(this.actions$.pipe(ofType(startupActions.finishAppInitializer))))
            )
        );
    }
}
